import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dict",
  "use": "icon-dict-usage",
  "viewBox": "0 0 1105 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1105 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dict\"><defs><style type=\"text/css\"></style></defs><path d=\"M321.361702 712.442553h468.425532a38.12766 38.12766 0 0 1 0 76.255319H321.361702a38.12766 38.12766 0 0 1 0-76.255319z\" fill=\"#2c2c2c\" p-id=\"3134\" /><path d=\"M887.829787 209.702128v616.034042a27.234043 27.234043 0 0 1-27.234042 27.234043H258.178723a43.574468 43.574468 0 0 1-43.574468-43.574468V691.744681a43.574468 43.574468 0 0 1 43.574468-43.574468H784.340426a43.574468 43.574468 0 0 0 43.574468-43.574468V147.06383a43.574468 43.574468 0 0 0-43.574468-43.574468H190.638298a43.574468 43.574468 0 0 0-43.574468 43.574468v729.87234a43.574468 43.574468 0 0 0 43.574468 43.574468h729.87234a43.574468 43.574468 0 0 0 43.574468-43.574468V209.702128a38.12766 38.12766 0 0 0-76.255319 0z\" fill=\"#2c2c2c\" p-id=\"3135\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dict.svg
// module id = OyZ9
// module chunks = 97